/**
 * Apendeaza mesaj de eroare
 * @param {Object} error Obiect eroare din jQuery Validate
 * @param {Object} element Elementul care a generat eroarea (jQuery object)
 * @returns {undefined}
 */
export const errorPlacement = (error, element) => {
	if (!element) {
		return;
	}

	const parentClass = element[0].type === 'checkbox' || element[0].type === 'radio' ? '.nj-group' : '.nj-form-item';
	error.appendTo(element[0].closest(parentClass));
};

/**
 * Evidentiaza elementul cu eroare
 * @param {HTMLElement} element Element de evidentiat
 * @returns {undefined}
 */
export const highlight = (element) => {
	if (!element || !(element instanceof HTMLElement)) {
		return;
	}

	switch (element.type) {
		case 'radio':
			element.closest('.nj-radio-group')?.classList.add('has-danger');
			break;
		case 'checkbox':
			document.querySelectorAll(`[name="${element.getAttribute('name')}"]`).forEach((elm) => elm.setAttribute('aria-invalid', 'true'));
			break;
		default:
			element.setAttribute('aria-invalid', 'true');
	}

	element.closest('.nj-form-item')?.classList.add('nj-form-item--error');
};

/**
 * Elimina evidentierea elementului daca nu mai are eroare
 * @param {HTMLElement} element Element de de-evidentiat
 * @returns {undefined}
 */
export const unhighlight = (element) => {
	if (!element || !(element instanceof HTMLElement)) {
		return;
	}

	switch (element.type) {
		case 'radio':
			element.closest('.nj-radio-group')?.classList.remove('has-danger');
			break;
		case 'checkbox':
			document.querySelectorAll(`[name="${element.getAttribute('name')}"]`).forEach((elm) => elm.removeAttribute('aria-invalid'));
			break;
		default:
			element.removeAttribute('aria-invalid');
	}

	element.closest('.nj-form-item')?.classList.remove('nj-form-item--error');
};

/**
 * Trimite in dataLayer evenimentul 'form_error'
 * @param {Object} event Eveniment eroare de la jQuery.validate()
 * @param {Object} validator Obiect jQuery.validate()
 * @param {Object} formDescriptor Descriptor form
 */
export const handleFormError = (event, validator, formDescriptor) => {
	window.dataLayer = window.dataLayer || [];

	validator.errorList.forEach((error) => {
		window.dataLayer.push({
			...formDescriptor,
			event: 'form_error',
			error_field: error.element.name,
			error_message: error.message,
		});
	});
};
